import { render, staticRenderFns } from "./help_notice_list.vue?vue&type=template&id=8505c92a&scoped=true"
import script from "./help_notice_list.vue?vue&type=script&lang=js"
export * from "./help_notice_list.vue?vue&type=script&lang=js"
import style0 from "./help_notice_list.vue?vue&type=style&index=0&id=8505c92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505c92a",
  null
  
)

export default component.exports